// frontend/admin-portal/src/services/customerService.js
import api from './axiosConfig';

export const customerService = {
    list: async (params = {}) => {
        const { data } = await api.get('/customers', { params });
        return data.data;   // { items, pagination }
    },

    // Returns { customer, aging } — matches the backend response exactly
    get: async (id) => {
        const { data } = await api.get(`/customers/${id}`);
        return data.data;   // ← was data.data.customer, this is the fix
    },

    create: async (payload) => {
        const { data } = await api.post('/customers', payload);
        return data.data.customer;
    },

    update: async (id, payload) => {
        const { data } = await api.put(`/customers/${id}`, payload);
        return data.data.customer;
    },

    remove: async (id) => {
        const { data } = await api.delete(`/customers/${id}`);
        return data;
    },

    aging: async (id) => {
        const { data } = await api.get(`/customers/${id}/aging`);
        return data.data;
    },

    statement: async (id, params = {}) => {
        const { data } = await api.get(`/customers/${id}/statement`, { params });
        return data.data;
    },

    recalcBalance: async (id) => {
        const { data } = await api.post(`/customers/${id}/recalc-balance`);
        return data.data;
    },
};